import React from "react";
import { useSelector } from "react-redux";
import ActionMenu from "widgets/ActionMenu";
import DTREE_ACTIONS, { dTreeActionList, MORE_ACTIONS } from "./DTreeActionLists/DTreeActions";

export function DTreeActions(props) {
	let { dependentValues } = props
		, user   = useSelector(state=>state.you)
		, $moreActions = <ActionMenu key="more-actions" icon="moreHorizontal" actionLists={MORE_ACTIONS} actionContext={{ user, dependentValues }} />
		, actionList = [$moreActions]
		;

	actionList.unshift(dTreeActionList(DTREE_ACTIONS, { user, dependentValues }));

	return <div className="grid-actions">{actionList}</div>;
}

export function getActionMetadata(data) {
	return data;
}

// TODO: Why do we need to export this function in order to test things in other files?
export const PRIVATE = { getActionMetadata };

const DTreeActionsCell = {
	key: "actions",
	name: "Actions",
	cellClass: "actions-cell",
	width: 150,
	formatter: DTreeActions,
	resizable: false,
	sortable: false,
	locked: false,
	getRowMetaData: getActionMetadata,
};

export default DTreeActionsCell;
